module.exports = __webpack_public_path__ + "static/media/usa-flag-bw.2b28ccf8.svg";